import React, {useEffect, useState} from 'react';
import { Container, Table } from 'react-bootstrap';
import classes from './style.module.css'
import League from './League'
import { connect } from "react-redux"
import { LEAGUE_TABLE_COLUMNS_STATIC} from '../../constants/Constants'
import { SET_SOCCER_LEAGUES_STATE, SET_SELECTION_STATE } from "../../redux/actions"
import {logInfo} from "../../util/log/logger"
import {getLeaguesByDate} from "../../service/backend-api-service"
import { getPreviousNthDayStr } from '../../util/date/date-utils';
import sortIconImage from "../../assets/images/sort_both.png"
import Spinner from "../UI/Spinner"
import { buildQueries } from '@testing-library/react';

const LeagueTable = (props) => {

    const [sortOrder, setSortOrder] = useState(true) // true - ascending and false - descending
    const [sortColumn, setSortColumn] = useState(null)
    const [loadingState, setLoadingState] = useState(0)

    const staticColumns = []
    for(let value in LEAGUE_TABLE_COLUMNS_STATIC) staticColumns.push(LEAGUE_TABLE_COLUMNS_STATIC[value])
    
    const dynamicColumns = []

    const finalColumns = [...staticColumns, ...dynamicColumns]; 

    const sortIconClickedHandler = columnId => {
        logInfo(`LeagueTable | sortIconClickedHandler | called. column id: ${columnId}`)
        setSortColumn(columnId)
        if(sortColumn === columnId) setSortOrder(!sortOrder)
    }

    const tableHeaders = finalColumns.map(column => {
        let sortIcon = null
        if(column.id !== LEAGUE_TABLE_COLUMNS_STATIC.ROW_NUM.id && column.id !== LEAGUE_TABLE_COLUMNS_STATIC.COUNTRY_FLAG.id)
            sortIcon =  <img src={sortIconImage} alt="Sort" onClick={() => sortIconClickedHandler(column.id)} />
        return(
            <th key={column.id}>{column.description} {sortIcon}</th>
        );
    })

    const compare = (a, b) => {
        if(a === b) return 0
        if(a === null || a === "-") return 1
        if(b === null || b === "-") return -1
        if(sortOrder) return a < b ? -1 : 1;
        else return a < b ? 1 : -1;
    }
    
    const sortLeaguesList = soccerLeaguesState => {
        const jsonFieldId = finalColumns.find(element => element.id === sortColumn).jsonFieldId
        logInfo(`LeagueTable | sortLeaguesList | sorting the table data: sort column: ${sortColumn}, sort order: ${sortOrder}, leagues count: ${soccerLeaguesState.length}, jsonFieldId: ${jsonFieldId}`)

        if(soccerLeaguesState.length > 0) {
            soccerLeaguesState.sort((a, b) => compare(a[jsonFieldId], b[jsonFieldId]))
            props.setSoccerLeaguesState(soccerLeaguesState)
        }
    }

    useEffect(() => {
        const fetchData = async () => {
            logInfo("LeagueTable | useEffect | called.")
            let date = props.selectionState.selectionDate
            logInfo(`LeagueTable | useEffect | date: ${date}.`)
            let leagues = await getLeaguesByDate(date)

            if(leagues.length === 0) {
                const currentDate = getPreviousNthDayStr(0)
                if(date === currentDate) {
                    date = getPreviousNthDayStr(1)
                    logInfo(`MatchTable | LeagueTable set selection date to previous date | date: ${date}.`)
                    const selectionState = {...props.selectionState} 
                    selectionState.selectionDate = date
                    props.setSelectionState(selectionState)
                }
            }
            
            logInfo(`LeagueTable | useEffect | leagues loaded. count: ${leagues.length}`)

            leagues = leagues.map(league => {
                for(let key in league) {
                    if(league[key] === null) {
                        league[key] = "-"
                    }
                }
                return league
            })
           
            props.setSoccerLeaguesState(leagues)
            if(leagues.length > 0) {
                setSortColumn(LEAGUE_TABLE_COLUMNS_STATIC.COUNTRY.id)
                setLoadingState(2) 
            }
            else setLoadingState(1)
       } 
       fetchData()
    }, [props.selectionState.selectionDate])

    useEffect(() => {
        if(sortColumn != null) {
            const soccerLeaguesState = [...props.soccerLeaguesState]
            sortLeaguesList(soccerLeaguesState)
        }
    }, [sortColumn, sortOrder])

    const itemList = props.soccerLeaguesState.map((item, index) => {
        const itemKey = item.id
        return (
            <League key={itemKey} finalColumns={finalColumns} item={item} index={index} />
        )
    });

    let contentBody = null
    if(loadingState === 0) {
        contentBody = <Spinner />
    }else if(loadingState === 1) {
        contentBody = <Spinner />
        // contentBody = <div>Data Not Available</div>
    }else {
        contentBody = <Table id="leaguesTable" striped bordered hover size="sm">
        <thead>
            <tr>
               {tableHeaders}
            </tr>
        </thead>
        <tbody>
            {itemList}
        </tbody>
    </Table>
    }


    return (
        <Container fluid className={classes.LeagueTable}>
            {contentBody}
        </Container>
    )
}

const mapStateToProps = state => {
    return {
        soccerLeaguesState: state.soccerLeaguesState,
        selectionState: state.selectionState
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setSoccerLeaguesState: payload =>
            dispatch({ type: SET_SOCCER_LEAGUES_STATE, payload: payload }),
        setSelectionState: payload =>
                dispatch({ type: SET_SELECTION_STATE, payload: payload })
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LeagueTable);